import React from "react";

interface Button
	extends React.DetailedHTMLProps<
		React.ButtonHTMLAttributes<HTMLButtonElement>,
		HTMLButtonElement
	> {}

export const Button = (props: Button) => {
	return (
		<button
			{...props}
			type="button"
			className={`bg-primary text-white rounded px-6 shadow-2xl items-center content-center pr-10 ${props.className}`}
		>
			{props.children}
		</button>
	);
};
